import React, { CSSProperties } from 'react';
import { Loader2 } from 'lucide-react';

type SpinnerNewProps = {
    size?: 'small' | 'medium' | 'large';
    style?: CSSProperties;
    className?: string;
    label?: string;
};

const sizeMap = {
    small: 20,
    medium: 32,
    large: 48,
};

const SpinnerNew = (props: SpinnerNewProps) => {
    const { size = 'medium', style, className, label } = props;

    return (
        <div
            className={`flex flex-col items-center justify-center h-full w-full gap-3 ${className || ''}`}
            style={style}
        >
            <Loader2
                size={sizeMap[size]}
                className="animate-spin"
                style={{ color: 'var(--accent)' }}
            />
            {label && (
                <span className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                    {label}
                </span>
            )}
        </div>
    );
};

export default SpinnerNew;
